<template>
  <DxDataGrid id="gridContainer"
              :allow-column-reordering="true"
              :data-source="dataSource"
              :row-alternation-enabled="true"
              :show-borders="true"
              :show-row-lines="true"
  >
    <DxScrolling row-rendering-mode="virtual"/>
    <DxPaging :page-size="15"/>
    <DxGroupPanel :visible="true"/>
    <DxGrouping :auto-expand-all="true"/>
    <DxRemoteOperations :group-paging="true"/>
    <DxFilterRow :visible="true"/>
    <DxFilterPanel :visible="false"/>
    <DxHeaderFilter :visible="true"/>
    <slot></slot>
  </DxDataGrid>
</template>
<script>
import 'devextreme/data/odata/store';
import {
  DxColumn,
  DxDataGrid,
  DxFilterPanel,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxHeaderFilter,
  DxPager,
  DxPaging,
  DxRemoteOperations,
  DxScrolling
} from 'devextreme-vue/data-grid';
import config from "devextreme/core/config";
import viMessages from "devextreme/localization/messages/vi.json";
import {loadMessages, locale} from "devextreme/localization";

config({
  defaultCurrency: 'VND'
});

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxPager,
    DxPaging, DxGroupPanel, DxGrouping, DxRemoteOperations, DxFilterRow, DxFilterPanel, DxHeaderFilter
  },
  props: {
    dataSource: {
      type: Object,
      default: () => {
      }
    }
  },
  created() {
    loadMessages(viMessages);
    console.log(navigator.language)
    locale("vi-VN");
  },
  data() {
    return {};
  },
};
</script>
<style>
#gridContainer {
  height: 80vh;
}
</style>
